import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

const WaitlistNoAccess = ({auth}) => {
    
    return (
    <>
        <div className="pt-5">    
            <Row className="primary-font-color" style={{ paddingTop:"50px", paddingBottom: "20px", overflow:"hidden" }}>
                <Col xs={1}></Col>
                <Col xs={10}>       
                        
                    <Row style={{ paddingTop: "20px", color:"#000000" }}>
                        <Col xs={12}>WAITLIST</Col>
                    </Row>                        
                    <Row className="mt-4" style={{fontSize:"0.9rem"}}>
                        <Col xs={12}>                                
                            Thanks for trying to login! It looks like your email doesn't have access. Feel free to <Link to="/login" style={{color:"#000000AA"}}>login</Link> again if you think you're here by mistake. <br /><br />At this time, the product is in Beta which means you either need an invite from a current user or you have to do a 1:1 onboarding with our founder (so he can learn from feedback to make the product better and you get more access to the product).
                            <br /><br />
                            You should have received a Waitlist email with more information where you can schedule your onboarding session.
                            <br /><br />
                            If you have any questions, just reply to the Waitlist email and it'll go directly to our founder.
                        </Col>
                    </Row>
                    
                </Col>                            
            </Row>
        </div>
    </>
    );    
};

function mapStateToProps({auth}) {
    return { auth };
}

export default connect(mapStateToProps)(WaitlistNoAccess);
